import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private dom: Document,
  ) { }

  updateURL(): void {
    let link = this.getCurrentLinkElement();
    if (!link) {
      link = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.dom.head.appendChild(link);
    }
    link.setAttribute('href', `${environment.canonicalUrl}${this.router.url}`);
  }

  private getCurrentLinkElement(): HTMLLinkElement {
    const links = this.dom.getElementsByTagName('link');
    for (const index in links) {
      if (links.hasOwnProperty(index)) {
        const element = links[index];
        if (element.rel === 'canonical') {
          return element;
        }
      }
    }
  }
}
